/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-thumbs-down{-webkit-transform:scale(-1,1);transform:scale(-1,1);margin-right:5px}.btn-error-feedback{font-size:22px}.fa-dark{color:#666}.fa-dark:hover{color:#000;border:none}.custom-modal .modal-content{width:50rem;margin:auto}"];
export { styles as styles };
